/**
 * Stories managed by Zillow Navbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent } from 'react';
import { HeaderMegaMenuData } from 'src/components/ZillowNavbar/page-frame-types/HeaderMegaMenuData';
import { NoDataAvailable } from 'src/components/ZillowNavbar/page-frame-types/NoDataAvailable';
import { HEADER_VERSIONS } from '../../../../constants';
import { UserNavigationData } from '../../types/UserNavigationData';
import { ZillowNavbarSections } from '../../../ZillowNavbarSections/ZillowNavbarSections';

export type ZillowAuthAccountManagementProps = {
    /** Data for MyZillowDropdown, including user avatar and navigation links. */
    userNavigationData: UserNavigationData | null;
    // /** Used for testing, bound to data-testid if set */
    // testID?: string;
    links: HeaderMegaMenuData | NoDataAvailable;
    zhlHost: string;
    version: HEADER_VERSIONS;
    onSignOut: () => void;
};

export const ZillowAuthAccountManagement: FunctionComponent<ZillowAuthAccountManagementProps> = ({
    version,
    userNavigationData,
    zhlHost,
    links,
    onSignOut,
}) => {
    if (!userNavigationData && !links) {
        return null;
    }

    if (!userNavigationData) {
        const signInLinks = links as HeaderMegaMenuData;
        signInLinks.sections = signInLinks.sections.filter(section => section.link.text === 'Sign in');
        return <ZillowNavbarSections version={version} zhlHost={zhlHost} links={signInLinks} />;
    }

    return (
        <ZillowNavbarSections
            onLinkClick={(_, event) => {
                event.preventDefault();
                onSignOut();
            }}
            links={{
                sections: [
                    {
                        link: {
                            text: 'Sign out',
                            href: '#',
                        },
                    },
                ],
            }}
            zhlHost={zhlHost}
            version={version}
        />
    );
};
